/* eslint-disable react-hooks/exhaustive-deps */
import _, { isString } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as manualAppraisalAction from '../../../store/actions/manualAppraisal.action';
import { CheckAccess, handleToast } from '../../../utils/handler';
import { NumberInput, ReactPagination } from '../../components/CommonPages';
import PopupWindow from '../../components/Popup';

const initialManualAppraisal = {
  UID: '',
  domainName: '',
  manualValue: '',
  isBlocked: false
};
const popupTypes = {
  editPopup: 'Edit Domain Value',
  newPopup: 'Modify Domain Value',
};
let searchFilter: any = null;
let initialManualAppraisalList: typeof initialManualAppraisal[] = [];
export default function ManualAppraisal() {
  const { t } = useTranslation();
  const [popupType, setPopupType] = useState('');
  const [manualAppraisalList, setManualAppraisalList] = useState<typeof initialManualAppraisal[]>(initialManualAppraisalList);
  const [manualAppraisal, setManualAppraisal] = useState<typeof initialManualAppraisal>(initialManualAppraisal);
  const [existDomain, setExistDomain] = useState<{ UID?: string }>({});
  const [showLoader, setShowLoader] = useState(false);

  const [appraisalPage, setAppraisalPage] = useState({
    page: 1,
    totalPages: 1,
    count: 0,
  });

  useEffect(() => {
    // getManualAppraisalCount()
    getManualAppraisals();
  }, []);

  const [filter, setFilter] = useState({ search: '', sortBy: 'createdAt', sortType: 'DESC', limit: 10, page: 1 });

  // const getManualAppraisalCount = () => {
  //   manualAppraisalAction.getManualAppraisalCount().then(response => {
  //     console.log(response)
  //     if (response)
  //       setAppraisalPage(prevState => ({
  //         ...prevState,
  //         totalPages: response.count / pageLimit,
  //         count: response.count,
  //       }))
  //   })
  // }
  const getManualAppraisals = (payload?: { search?: string; filterBy?: string; filterType?: string; sortBy?: string; sortType?: string; limit?: number; page?: number }) => {
    // let { search = "", filterBy = "", filterType = "", sortBy = "createAt", sortType = "DESC", limit = 10, page = 1 } = filters
    setShowLoader(true);
    setFilter({ ...filter, ...payload });
    manualAppraisalAction.getManualAppraisals({ ...filter, ...payload }).then((response) => {
      if (response) {
        initialManualAppraisalList = response.manualAppraisal;
        setManualAppraisalList(response.manualAppraisal);
        setAppraisalPage((prevState) => ({
          ...prevState,
          ...response.pagination,
        }));
      }
      setShowLoader(false);
    });
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (checkFormValidation()) {
      let payload = {
        isBlocked: manualAppraisal.isBlocked,
        domainName: manualAppraisal.domainName,
        manualValue: parseInt(manualAppraisal.manualValue) || 0,
      };
      let response: any;
      let domainUID = manualAppraisal.UID;
      if (existDomain && existDomain.UID) {
        domainUID = existDomain.UID;
      }
      if (domainUID) {
        response = await manualAppraisalAction.patchManualAppraisals(domainUID, payload);
      } else {
        response = await manualAppraisalAction.createManualAppraisals(payload);
      }
      if (response) {
        if (response.status === 200) {
          setPopupType('');
          getManualAppraisals();
          setExistDomain({});
          handleToast({ message: 'Updated domain details' }, 'success');
        } else {
          let data = response['data'];
          if (isString(data)) {
            handleToast({ message: response['data'] });
          }
          setExistDomain(response['data']);
        }
      }
    } else {
      handleToast({ message: 'Please enter domain value' });
    }
  };

  const checkFormValidation = () => {
    if (!manualAppraisal.domainName) {
      return false;
    }
    if (!parseInt(manualAppraisal.manualValue) && !manualAppraisal.isBlocked) {
      // console.log('firstddd')
      return false;
    }
    return true;
  };

  const handleAppraisalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === 'domainName') {
      setExistDomain({});
    }
    setManualAppraisal({ ...manualAppraisal, [name]: value });
  };
  const deleteManualAppraisal = (UID: string) => {
    if (window.confirm('Are you sure you want to delete this appraisal value')) {
      manualAppraisalAction.delManualAppraisals(UID).then((response) => {
        if (response) {
          getManualAppraisals();
        }
      });
    }
  };
  const onPageChange = (pageNumber: number) => {
    getManualAppraisals({ page: pageNumber });
  };
  const sortTable = (sortBy: string) => {
    getManualAppraisals({ sortBy, sortType: filter.sortType === 'DESC' ? 'ASC' : 'DESC' });
  };
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter((prev) => ({ ...prev, page: 1, search: e.target.value }));
    if (searchFilter) {
      clearTimeout(searchFilter);
    }
    searchFilter = setTimeout(function () {
      getManualAppraisals({ page: 1, search: e.target.value });
    }, 500);
  };
  return (
    <div className=" no-header clearfix">
      <div className="d-flex flex-column py-1 flex-sm-row align-items-center justify-content-between">
        <input type="text" className="form-control admin-search " id="search" name="search" value={filter.search} onChange={onSearch} placeholder="search by domain name" required />
        {CheckAccess('ChangeAppraisedDomainValues') && (
          <button
            className="float-right btn btn-primary"
            onClick={() => {
              setPopupType(popupTypes.newPopup);
              setManualAppraisal(initialManualAppraisal);
            }}
          >
            <i className="fa fa-plus mr-2"></i>Modify domain price
          </button>
        )}
      </div>
      <div className="main-box-body clearfix">
        <div className="table-responsive">
          <table className="table user-list table text-center table table-striped table-hover ">
            <thead>
              <tr>
                <th>
                  DomainName <i className="ml-2 fa-solid fa-sort" onClick={() => sortTable('domainName')} />
                </th>
                <th>
                  DomainValue <i className="ml-2 fa-solid fa-sort" onClick={() => sortTable('manualValue')} />
                </th>
                {CheckAccess('ChangeAppraisedDomainValues') && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {_.isArray(manualAppraisalList) && manualAppraisalList.length === 0 ? (
                <tr className="text-center">
                  <td colSpan={3}>{showLoader ? t('loading...') : <span className="text-danger ffs-18">No Data Found!</span>}</td>
                </tr>
              ) : (
                _.isArray(manualAppraisalList) &&
                manualAppraisalList.map((manualAppraisalData: { domainName: string; manualValue: string; UID: string, isBlocked: boolean }, index: number) => (
                  <tr key={index} className="table-row-action c-pointer">
                    <td>{manualAppraisalData.domainName}</td>
                    <td>{manualAppraisalData.manualValue}</td>
                    {CheckAccess('ChangeAppraisedDomainValues') && (
                      <td>
                        <div className="d-flex justify-content-center">
                          <i
                            className="fas fa-edit  text-success"
                            onClick={() => {
                              setManualAppraisal(manualAppraisalData);
                              setPopupType(popupTypes.editPopup);
                            }}
                          ></i>
                          <i
                            className="fas fa-trash  text-danger ml-2"
                            onClick={() => {
                              deleteManualAppraisal(manualAppraisalData.UID);
                            }}
                          ></i>
                        </div>
                        <div className="float-right mb-2"></div>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <ReactPagination currentPage={filter.page} totalPages={appraisalPage.totalPages} onPageChange={onPageChange} />
        </div>
      </div>
      {popupType !== '' && (
        <PopupWindow onClose={() => setPopupType('')} header={popupType}>
          <div className="model p-3">
            <div className="content form-group">
              <form noValidate className="col-12 " onSubmit={submit}>
                <div className="input-group mb-3">
                  <input type="text" placeholder="Enter Domain Name" className="form-control" value={manualAppraisal.domainName} name="domainName" onChange={handleAppraisalChange} />
                </div>
                <div className=" mb-3">
                  <NumberInput placeholder="Domain price" value={manualAppraisal?.manualValue || ''} name="manualValue" onChange={handleAppraisalChange} />
                  <span className="info-text text-danger">*Domain price should be full number</span>
                </div>
                <div className="form-check-label fs-14 col-12 pl-0">
                  <input type="checkbox" name="isBlocked" defaultChecked={manualAppraisal.isBlocked} onClick={() => setManualAppraisal({ ...manualAppraisal, isBlocked: !manualAppraisal.isBlocked })} id="isBlocked"
                    className={"form-control saw-check-box "} />
                  <div className="">
                    Block this domain
                  </div>
                </div>
                <div>
                  {_.isEmpty(existDomain) ? (
                    <button className="float-right btn btn-grad normal-btn input-group-text" onSubmit={submit}>
                      Submit
                    </button>
                  ) : (
                    <div className="text-center">
                      <label>This domain is already exist, still want to</label>
                      <div className="d-flex justify-content-center">
                        <button className="btn btn-outline-primary normal-btn" onClick={submit}>
                          Overwrite ?
                        </button>{' '}
                        <span className="p-1">or</span>
                        <button
                          className="btn btn-outline-danger normal-btn"
                          onClick={() => {
                            setPopupType('');
                            setExistDomain({});
                          }}
                        >
                          Cancel?
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </PopupWindow>
      )}
    </div>
  );
}
